// extracted by mini-css-extract-plugin
export default {"home_page_title":"ULPromoPlan_home_page_title__hus7z"};